﻿class StickyHeader {
    constructor() {
        this.$elm = $('.header');
        this.setEventListeners();

        this.stickyPoint = 0;
        this.lastScrollTop = 0;
    }

    setEventListeners() {
        $(window).on('scroll', this.onScroll.bind(this)).trigger('scroll');
    }

    onScroll(event) {
        var scrollTop = $.scrollY();
        var scrollDirectionIsDown = (scrollTop > this.lastScrollTop);

        if (scrollTop > this.stickyPoint) {
            this.$elm.addClass('header--isSticky');
        } else {
            this.$elm.removeClass('header--isSticky');
        }

        //console.log(scrollTop, scrollDirectionIsDown);

        this.lastScrollTop = scrollTop;
    }
}

export default StickyHeader;